import { Volume2 } from "lucide-react";
import { speak } from "@/lib/api";
import { WordIcon } from "@/components/WordIcon";
import { PronounceButton } from "@/components/PronounceButton";
import { useTranslations, Translation } from "@/lib/translations";

export function VocabStep({ vocabulary }) {
  const { map, rtl } = useTranslations(vocabulary);
  return (
    <div className="space-y-3">
      {vocabulary.map((v, i) => (
        <div
          key={v.word}
          className={`rise rise-${Math.min(i, 3)} bg-white rounded-2xl border-2 border-slate-200 border-l-8 border-l-orange-500 p-5`}
          data-testid={`lesson-vocab-card-${i}`}
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-center gap-3">
              <WordIcon word={v} testId={`lesson-vocab-icon-${i}`} />
              <div>
                <h3 className="font-display text-2xl font-bold" data-testid={`lesson-vocab-word-${i}`}>{v.word}</h3>
                <Translation text={map[v.word]} rtl={rtl} testId={`lesson-vocab-translation-${i}`} />
              </div>
            </div>
            <div className="flex flex-col gap-2 items-end">
              <button
                onClick={() => speak(`${v.word}. ${v.example}`, 0.9)}
                data-testid={`lesson-vocab-audio-btn-${i}`}
                aria-label="Écouter"
                className="shrink-0 w-12 h-12 rounded-full bg-slate-900 text-amber-400 hover:bg-orange-500 hover:text-white grid place-items-center transition-colors"
              >
                <Volume2 className="w-6 h-6" />
              </button>
            </div>
          </div>
          <p className="mt-1 text-slate-700">{v.definition}</p>
          {v.example && (
            <p className="mt-3 text-sm italic text-slate-600 bg-slate-50 rounded-lg px-3 py-2">« {v.example} »</p>
          )}
          <div className="mt-3 flex items-center gap-3">
            <PronounceButton word={v.word} testId={`lesson-vocab-mic-btn-${i}`} />
            <span className="text-xs font-bold uppercase text-slate-500">Répétez le mot</span>
          </div>
        </div>
      ))}
    </div>
  );
}
